import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';
import { inputPlaceholder } from '../../layout/reset';

interface WrapperProps {
  $hasError?: boolean;
  $disabled?: boolean;
}

export const Wrapper = styled.div.withConfig({ componentId: 'sc-1lvnr0e-0' })<WrapperProps>`
    position: relative;
    display: flex;
    align-items: stretch;
    background-color: var(--c-bg-main);
    border: 1px solid var(--c-input-border);
    box-shadow: ${(props) => props.theme.boxShadow.inset};
    border-radius: ${(props) => props.theme.size.borderRadius};

    ${({ $hasError }) =>
      $hasError
        ? css`
                  border-color: var(--c-input-error-border);
              `
        : css`
                  &:focus-within {
                      border-color: var(--c-input-border-focus);
                  }
              `}

    ${({ $disabled }) =>
      $disabled &&
      css`
            opacity: 0.37;
            cursor: not-allowed;
        `}
`;

export const Prefix = styled.div.withConfig({ componentId: 'sc-1lvnr0e-1' })`
    flex-shrink: 0;
    display: flex;
    align-items: center;
    max-width: 50%;
    padding: 0 ${size(2)};
    background-color: var(--c-bg-alt);
    color: var(--c-text-muted);
    border-right: 1px solid var(--c-border-main);
    user-select: none;
    cursor: default;
`;

export const Truncate = styled.div.withConfig({ componentId: 'sc-1lvnr0e-2' })`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const Unit = styled.div.withConfig({ componentId: 'sc-1lvnr0e-3' })`
    flex-shrink: 0;
    display: flex;
    align-items: center;
    padding-right: ${size(2)};
    color: var(--c-text-muted);
    user-select: none;
    cursor: default;
`;

export const Input = styled.input.withConfig({ componentId: 'sc-1lvnr0e-4' })`
    ${inputPlaceholder};
    flex: 1 1 auto;
    display: block;
    width: 100%;
    height: ${(props) => props.theme.size.inputHeight};
    padding: 0 ${size(2)};
    background-color: transparent;
    font-size: var(--font-size-input);
    border: none;
    border-radius: 0;
    box-shadow: none;
    -moz-appearance: none;
    -webkit-appearance: none;

    &:focus {
        outline: none;
    }

    &[disabled] {
        cursor: not-allowed;
    }

    &:read-only {
        color: var(--c-text-muted);
    }
`;
